import {
  GET_DETAILED_WFH_DATA_SUCCESS,
  GET_DETAILED_WFH_DATA,
  GET_SUMMARY_WFH_DATA_SUCCESS,
  GET_SUMMARY_WFH_DATA,
  GET_DETAILED_WFH_DATA_ERROR,
  EXPORT_DETAILED_WFH_DATA,
  EXPORT_DETAILED_WFH_DATA_SUCCESS,
  EXPORT_DETAILED_WFH_DATA_ERROR,
} from "./actionType"

const initialState = {
  // detailed
  workfromhomedetailedSuccessList: {},
  workfromhomedetailedError: null,
  getworkfromhomeetailed: null,
  // summary
  workfromhomesummarySuccessList: {},
  workfromhomesummaryError: null,
  getworkfromhomesummary: null,

  exportWFHError: null,
  isExportingWFH: false,
}

const workfromhomeReducer = (state = initialState, action) => {
  switch (action.type) {
    // detailed work form home
    case GET_DETAILED_WFH_DATA:
      state = {
        ...state,
        getworkfromhomeetailed: null,
        getworkfromhomeetailedError: null,
      }
      break

    case GET_DETAILED_WFH_DATA_SUCCESS:
      state = {
        ...state,
        workfromhomedetailedSuccessList: action.payload,
        workfromhomedetailedError: null,
      }
      break

    case GET_DETAILED_WFH_DATA_ERROR:
      state = { ...state, workfromhomedetailedError: action.payload }
      break

    // summary work form home
    case GET_SUMMARY_WFH_DATA:
      state = {
        ...state,
        getworkfromhomesummary: action.payload,
      }
      break

    case GET_SUMMARY_WFH_DATA_SUCCESS:
      state = {
        ...state,
        workfromhomesummarySuccessList: action.payload,
        workfromhomesummaryError: null,
      }
      break

    default:
      state = { ...state }
      break

    // Export detailed WFH
    case EXPORT_DETAILED_WFH_DATA:
      return {
        ...state,
        isExportingWFH: true,
        exportWFHError: null,
      }

    case EXPORT_DETAILED_WFH_DATA_SUCCESS:
      return {
        ...state,
        isExportingWFH: false,
        exportWFHError: null,
      }

    case EXPORT_DETAILED_WFH_DATA_ERROR:
      return {
        ...state,
        isExportingWFH: false,
        exportWFHError: action.payload,
      }
  }
  return state
}

export default workfromhomeReducer
